import { api } from '../api';

export interface PersonAccessResponse {
  message: string;
  person: Record<string, unknown>;
}

export interface PromoteTeacherResponse {
  message: string;
  person: Record<string, unknown>;
}

export const personenAccessApi = {
  lockAccess: async (personId: string | number): Promise<PersonAccessResponse> => {
    const url = `/api/personen/${encodeURIComponent(String(personId))}/access/lock`;
    return api.post<PersonAccessResponse>(url, {});
  },
  unlockAccess: async (personId: string | number): Promise<PersonAccessResponse> => {
    const url = `/api/personen/${encodeURIComponent(String(personId))}/access/unlock`;
    return api.post<PersonAccessResponse>(url, {});
  },
  /** Die Lehrerrolle gibt es nur mit mindestens einem Fach (T-0189) und einem eindeutigen Kürzel. */
  promoteTeacher: async (
    personId: string | number,
    subjects: number[],
    shortCode?: string,
  ): Promise<PromoteTeacherResponse> => {
    const url = `/api/personen/${encodeURIComponent(String(personId))}/promote-teacher`;
    return api.post<PromoteTeacherResponse>(url, shortCode ? { subjects, shortCode } : { subjects });
  },
};
